import React from "react";
import { useTranslation } from "react-i18next";

import { ModalBasic, ModalBasicProps, Typography } from "@/components";
import { COLORS } from "@/utils/colors";

type Props = Pick<ModalBasicProps, "open" | "onClose"> & {
  type: string;
  onConfirm: VoidFunction;
};

export const ModalCancelConfirm: React.FC<Props> = ({ open, onClose, type, onConfirm }) => {
  const { t } = useTranslation();
  return (
    <ModalBasic
      open={open}
      onClose={onClose}
      title={t(`ASK_RESENDING_${type}`)}
      actionButton={{
        label: t("CANCEL_APPLICATION"),
        onClick: onConfirm,
      }}
      weakActionButton={{
        label: t("CANCEL"),
        onClick: onClose,
      }}
      color={COLORS.WARNING}
    >
      <Typography>{t("YOU_NEED_TO_RESTART")}</Typography>
    </ModalBasic>
  );
};
